import { useQuery } from 'react-query';
import {
	getAllBookedParticipantSessions,
	getAllMentors,
	getAllSessions,
	getMentorAvailabilities,
	getRecordingBySessionId,
	getSessionById,
} from 'src/apis/session';
import {
	FilterQueryInput,
	GetAllMentorsAPIResponse,
	GetAllSessionsAPIResponse,
	GetBookedSessionsByIdAPIResponse,
	GetMentorAvailabilitiesAPIResponse,
	GetSessionByIdAPIResponse,
	GetSessionRecordingByIdAPIResponse,
} from 'types';

export const useGetSessionRecordingBySessionIdQuery = (
	sessionId?: string,
	onComplete?: (data: GetSessionRecordingByIdAPIResponse) => void,
	handleError?: () => void,
) => {
	return useQuery({
		queryKey: ['getRecordingBySessionId', sessionId],
		queryFn: async () => (await getRecordingBySessionId(sessionId ?? '')) as GetSessionRecordingByIdAPIResponse,
		staleTime: 0,
		enabled: !!sessionId,
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
		onError() {
			handleError && handleError();
		},
	});
};

export const useGetAllSessions = (
	filterData: FilterQueryInput,
	onComplete?: (data: GetAllSessionsAPIResponse) => void,
	handleError?: () => void,
) => {
	return useQuery({
		queryKey: ['getAllSessions', filterData.filterQuery],
		queryFn: async () => (await getAllSessions(filterData)) as GetAllSessionsAPIResponse,
		staleTime: 0,
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
		onError() {
			handleError && handleError();
		},
	});
};
export const useGetAllBookedParticipantSessions = (
	levelUpParticipantId?: string,
	onComplete?: (data: GetBookedSessionsByIdAPIResponse) => void,
	handleError?: () => void,
) => {
	return useQuery({
		queryKey: ['getAllBookedParticipantSessions', levelUpParticipantId],
		queryFn: async () =>
			(await getAllBookedParticipantSessions(levelUpParticipantId)) as GetBookedSessionsByIdAPIResponse,
		staleTime: 0,
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
		onError() {
			handleError && handleError();
		},
	});
};

export const useGetAllMentors = (onComplete?: (data: GetAllMentorsAPIResponse) => void, handleError?: () => void) => {
	return useQuery({
		queryKey: ['getAllMentors'],
		queryFn: async () => (await getAllMentors()) as GetAllMentorsAPIResponse,
		staleTime: 0,
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
		onError() {
			handleError && handleError();
		},
	});
};

export const useGetSessionByIdQuery = (
	id?: string,
	token?: string,
	onComplete?: (data: GetSessionByIdAPIResponse) => void,
	handleError?: () => void,
) => {
	console.log('LevelUp: inside hooks: sessionId useGetSessionByIdQuery', id, token);
	return useQuery({
		queryKey: ['getSessionById', id],
		queryFn: async () => (await getSessionById(id ?? '', token ?? '')) as GetSessionByIdAPIResponse,
		staleTime: 5000,
		enabled: !!id,
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
		onError() {
			handleError && handleError();
		},
	});
};

export const useGetMentorAvailablities = (
	mentorId: string,
	onComplete?: (data: GetMentorAvailabilitiesAPIResponse) => void,
	handleError?: () => void,
) => {
	return useQuery({
		queryKey: ['getMentorAvailabilities', mentorId],
		queryFn: async () => (await getMentorAvailabilities(mentorId ?? '')) as GetMentorAvailabilitiesAPIResponse,
		staleTime: 5000,
		enabled: !!mentorId,
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
		onError() {
			handleError && handleError();
		},
	});
};
